//
// Form Validation Plugin
// @author rw
// @param requierments = an object describing the form fields.  Must be formatted as such:
// var requirements = {
//      'field_name' : {                // object keys are the form 'name' attributes.
//          required : 'true',          // boolean denoting whether the field is required or not
//          regex :                     // regex defining the field input.  if none pass null.
//      },
//      'field_name2' : {
//          // ...
//      }
// }
//
// NOTE: The requirements for each form are to be stored in separate files, so that these rules can be shared with
// the back end team.

(function (root, factory) {
    'use strict';
    if (typeof module !== 'undefined') {
        // CommonJS
        factory(module, require('dibs-jquery-shim'), require('underscore'));
    } else {
        var m = {};
        // Browser globals
        factory(m, root.jQuery, root._);
    }
}(typeof window === 'undefined' ? global : window, function (module, $, _) {

    'use strict';

    var methods,
        current_event,
        /**
         * Convenience functions for sending either success or error below:
         * @param name - field name
         * @param message - message to pass to other scripts via event (sub-pub)
         * @return {Boolean}
         */
        sendSuccess = function (name, $field) {
            var config = this.data('dibsValidation');
            var requirements = config.requirements || {};
            var req = requirements[name] || {};

            $field = $field || this.find('[name=' + config.prefix + name + ']');
            req.status = true;
            req.message = 'success';
            $field.trigger('formErrorResolved', [$field, requirements[name], current_event]);
            return true;
        },

        /**
         * @param name - field name
         * @param message - message to pass to other scripts via event
         * @return {Boolean}
         */
        sendError = function (name, message, $field) {
            var config = this.data('dibsValidation');
            var req = config.requirements[name] || {};

            $field = $field || this.find('[name=' + config.prefix + name + ']');
            req.status = false;
            req.message = message || req.messages[name];
            $field.trigger(('formError'), [$field, req, current_event]);
            return false;
        },

        _validateOnChange = function () {
            var self = this;
            var events = ['change', 'focusout'];
            var dibsValidation = this.data('dibsValidation') || {};
            var customEvents = _.result(dibsValidation.options, 'on');
            if (customEvents) {
                events = events.concat(customEvents.split(' '));
            }
            events = _.map(events, function (s) {
                return s + '.dibsValidation.dibsValidationBlur';
            });
            events = events.join(' ');
            self.on(events, 'input, select, textarea', function (e) {
                // on focusin - remove the invalid class
                if ($(this).attr('type') !== 'submit') {
                    current_event = e;
                    methods.validateField.call(self, this);
                }
            });
        },

        _toggleRequire = function (fieldNames, onOff) {
            var config = this.data('dibsValidation');
            if (!fieldNames) {
                fieldNames = _.keys(config.requirements);
            } else if (!$.isArray(fieldNames)) {
                fieldNames = [fieldNames];
            }
            _.each(fieldNames, function (fieldName) {
                config._disableRequire[fieldName] = onOff;
            });
        },

        // Validates 1 form field based on that fieild's name.
        // Note: this function sets the internal status pointer for each field to true or false.
        _validateField = function (name, $field) {
            var self = this;
            var config = this.data('dibsValidation');
            var regexShouldMatch = true;
            var message = 'This field is invalid';
            var customValidators;
            var fieldIsRequired;
            var regexTesterFn;
            var customRes;
            var requirement;
            var type;
            var value;
            var test;
            var len;
            var i;

            if (name && typeof name === "object") {
                $field = (name instanceof $) ? name : self.find(name);
                name = $field.data('ruleset') || $field.attr('name');
            }

            if (name && name.indexOf(config.prefix) !== -1) {
                name = name.substr(config.prefix.length);
            }

            $field = $field || self.find('[name="' + config.prefix + name + '"]');

            requirement = config.requirements[name];

            // Use custom validators if found
            customValidators = config.customValidators[name];
            if (customValidators) {
                for (i = 0, len = customValidators.length; i < len; i++) {
                    // Grab the response from the custom validator function
                    customRes = customValidators[i].callback.call(customValidators[i].context || self, $field);
                    // If the custom validator callback returns a string, then use that as the message
                    if (typeof customRes === 'string') { message = customRes; }
                    // if the custom validator return value is anything but true, trigger a send error
                    if (customRes !== true) {
                        return sendError.call(self, name, message, $field);
                    }
                }
                // If there are no further requirements for this field, then we can send a success
                if (!requirement) {
                    return sendSuccess.call(self, name, $field);
                }
            }

            // ignore fields with no defined requirements:
            if (requirement) {
                type = $field.attr('type');
                value  = false;
                // Firstly, set the value to test against.
                // If the field is a radio, checking for the value is not enough, you have to check for the value of
                // the "checked" radio:
                if (type === 'radio') {
                    value = (self.find('input[name="' + $field.attr('name') + '"]', self).length) ?
                            self.find('input[name="' + $field.attr('name') + '"]', self).filter(':checked').val() : '';
                } else {
                    value = $field.val();
                }

                // Determine if the field is required by examining the rules and
                // see if the requirement wasn't disabled by disableRequire method
                fieldIsRequired = requirement.required && !config._disableRequire[name];
                // if field is not required, and is empty, return true:
                if (!fieldIsRequired && !value) {
                    return sendSuccess.call(self, name, $field);
                    // if field is required and empty, return false:
                }

                if (fieldIsRequired && !value) {
                    message = 'This field is required';
                    // For required fields, the error message should be stored under
                    // requirement.messages.default_message -- check for that before using default:
                    if (requirement.messages) {
                        if (requirement.messages.default_message) {
                            message = requirement.messages.default_message;
                        }
                    }
                    return sendError.call(self, name, message, $field);
                    // If the field has a value, and a regex, test against the regex:
                }

                if (requirement.regex_rules || requirement.regex_nomatch_rules) {
                    test = true;

                    // used to test regex validations
                    regexTesterFn =  function (val, key) {
                        var reg, currTest;
                        if (!test || !val) {
                            return;//No need to test further
                        }
                        reg = new RegExp(val);
                        currTest = reg.test(value);

                        // TODO: remove when PHantomJS version fix this regex bug
                        // PhantomJS toggle true and false on every regex test run
                        // This fix makes it stable so it will return the 'right' value every time
                        reg.test(value);

                        if (currTest !== regexShouldMatch) {
                            test = false;
                            // Set message based on key in messsages array:
                            message = requirement.messages && requirement.messages[key] ? requirement.messages[key] : message;
                        }
                    };

                    regexShouldMatch = true;
                    // for each regex - test against value and return for the first falsy evaluation.
                    _.each(requirement.regex_rules, regexTesterFn);

                    regexShouldMatch = false;
                    // for each regex_nomatch_rules - send success only if the pattern is NOT matched
                    _.each(requirement.regex_nomatch_rules, regexTesterFn);

                    // if only 1 test failed then 'test' will be false. Return a false response in this case:
                    if (test) {
                        // If all tests pass, return truthy evaluation:
                        return sendSuccess.call(self, name, $field);
                    }
                    return sendError.call(self, name, message, $field);
                }
                return sendSuccess.call(self, name, $field);
            }
            // for all fields with no defined requirements -- return true (ie. leave these alone)
            return true;
        };


    // *** PUBLIC FUNCTIONS :
    // *** the following functions are exposed so they can be accessed via other scripts.

    /**
     * Form Validation Plugin - The following functions are exposed so they can be accessed via other scripts.
     * They are used in {@link dibsValidation}
     * @namespace methods
     */
    methods = {
        /**
         * @memberof methods
         * @param requirements - an object describing the form fields
         * @param options
         */
        init: function (requirements, options) {
            var self = this;
            var yesOnSubmit;
            var validateOnChange;
            var config;
            options = options || {};
            yesOnSubmit = options.validateOnSubmit === false ? options.validateOnSubmit : true;
            validateOnChange = options.validateOnChange === false ? options.validateOnChange : true;
            config = {
                requirements : requirements || {},
                options: options,
                _origReqs : {},
                prefix : options.fieldNamePrefix || 'field-input-',
                isEnableScroll : options.isEnableScroll === false ? options.isEnableScroll : true,
                submitOnValidation : options.submitOnValidation === false ? options.submitOnValidation : true,
                customValidators : {},
                _disableRequire : {}
            };
            self.data('dibsValidation', config);

            // on submit,  check the status of each field.  If the form is not valid, trigger an event signifying
            // error, this event can be picked up on a per case basis to display an error message.
            if (yesOnSubmit) {
                self.on('submit.dibsValidation', function (e) {
                    current_event = e;
                    methods.validateForm.call(self, e);
                });
            }
            // for each form element, bind focusin and focusout events:

            if (validateOnChange) {
                _validateOnChange.call(self);
            }
            return self;
        },
        /**
         * @memberof methods
         * @param e
         * @returns {boolean}
         */
        validateForm: function (e) {
            var self = this;
            // will be the location of the first missed field to scroll to.
            var newTop = false;
            // noInvalidFields denotes that no fields have been marked invalid
            // whilst checking all fields. If any field does not pass validation
            // - the form may not submit.
            var noInvalidFields = true;
            var config = this.data('dibsValidation');
            var requirements = config.requirements;
            // update the field status for each of the form inputs- ie. style change.
            self.find('input, select, textarea').each(function () {
                var $this = $(this);
                var name = $this.data('ruleset') || $this.attr('name');
                var valid;

                if (name && name.indexOf(config.prefix) !== -1) {
                    name = name.substr(config.prefix.length);
                }
                // Note: only check the given field if it is not a submit button, AND it is in the requirements:
                if ($this.attr('type') !== 'submit' && (requirements[name] || config.customValidators[name])) {
                    valid = methods.validateField.call(self, this);
                    // if the field is not valid, scroll to the location of that field:
                    if (!valid) {
                        noInvalidFields = false;
                        if (config.isEnableScroll) {
                            if (!newTop) {
                                // to find the top positioning use jQuery's offset() - however, if the input is
                                // hidden, the top offset will always be the current scrollTop of the page, so grab
                                // the offset of the closest parent element:
                                if ($this.attr('type') === 'hidden' || $this.css('display') === 'none') {
                                    newTop = $this.parent().offset().top - 50;
                                } else {
                                    newTop = $this.offset().top - 50;
                                }
                            }
                            window.clearTimeout(self.scrollTimeout);
                            self.scrollTimeout = window.setTimeout(function () {
                                $('html').animate({scrollTop: newTop}, 'slow');//IE, FF
                                $('body').animate({scrollTop: newTop}, 'slow');//chrome, don't know if safari works
                            }, 500);
                        }
                    }
                }
            });
            //If submitOnValidation is false or fields are invalid prevent default event
            if (!noInvalidFields || !config.submitOnValidation) {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                //return false only if fields are invalid
                if (!noInvalidFields) {
                    return false;
                }
            }
            //Do not submit automatically if submitOnValidation is explicitly set to false (default is true)
            if (config.submitOnValidation) {
                self.trigger('validationSuccess');
            }
            return true;
        },
        /**
         * Creates an easily reversible change in a validation rule.
         * @memberof methods
         * @param {String} name
         * @param {Object} req Object that follows requirements pattern above
         */
        reqChange : function (name, req) {
            var config = this.data('dibsValidation') || {};
            var requirements = config.requirements || {};
            var origReqs = config._origReqs || {};

            requirements[name] = requirements[name] || {};
            // Should not overwrite origReq if it already exists
            if (!origReqs[name]) {
                origReqs[name] = $.extend(true, {}, requirements[name]);
            }
            $.extend(true, requirements[name], req);
            return this;
        },
        /**
         * Reverts a requirement change to what you originally passed it
         * @memberof methods
         * @param {String} name
         */
        undoReqChange : function (name) {
            var config = this.data('dibsValidation') || {};
            var requirements = config.requirements || {};
            var origReqs = config._origReqs || {};

            if (!origReqs[name]) {
                return false;
            }
            requirements[name] = origReqs[name];
            origReqs[name] = false;
            return this;
        },
        /**
         * To simply disable the 'required'
         * validation of a field temporarily (making it
         * optional), but leave other validation intact.
         * @param {string|string[]} [fieldNames]
         *      The field names or rulsets you would like to
         *      make optional. If left out, then all required
         *      fields will become optional.
         * @return jQuery
         */
        disableRequire: function (fieldNames) {
            _toggleRequire.call(this, fieldNames, true);
            return this;
        },
        /**
         * To undo the disabling of a field's requirement
         * with disableRequire. If a field doesn't have
         * 'required === true' in it's configuration
         * it will stay that way.
         * @param {string|string[]} [fieldNames]
         * @returns jQuery
         */
        enableRequire: function (fieldNames) {
            _toggleRequire.call(this, fieldNames, false);
        },
        /**
         * If you want to disable the validation on change
         * events ('focusout' and 'change' events)
         */
        disableOnChangeValidation: function () {
            this.off('.dibsValidationBlur');
        },
        /**
         * if you want to enable the validation on
         * change and focusout events.
         */
        enableOnChangeValidation: function () {
            _validateOnChange.call(this);
        },
        /**
         * If the standard config doesn't meet your needs, you can add a custom validator function
         * @memberof methods
         * @param obj
         * @returns {jQuery}
         */
        addCustomValidator : function (name, callback, context) {
            var config = this.data('dibsValidation');
            if (config && config.customValidators) {
                if (!config.customValidators[name]) {
                    config.customValidators[name] = [];
                }
                config.customValidators[name].push({
                    callback: callback,
                    context: context
                });
            }
            return this;
        },

        /**
         * Adds a set of custom validators.
         * @memberof methods
         * @example
         * // You can use any of the following map formats:
         *      { field-name : "callback-function" }
         *      { field-name : { callback: "callback-function", context: "callback-context" }
         *      { field-name : [ "callback-function", "callback-function", ... ] }
         *      { field-name : [ { callback: "callback-function", context: "callback-context" }, ... ] }
         * @param {Object} map An object with one of the above formats
         * @param {Object} context A context to use if a map value does not have its own context
         * @returns {jQuery}
         */
        addCustomValidators : function (map, context) {
            var callback;
            var key;
            var len;
            var i;
            for (key in map) {
                if (map.hasOwnProperty(key)) {
                    if (!$.isArray(map[key])) {
                        map[key] = [map[key]];
                    }
                    for (i = 0, len = map[key].length; i < len; i++) {
                        callback = (typeof map[key][i] === 'function') ? map[key][i] : map[key][i].callback;
                        methods.addCustomValidator.call(this, key, callback, map[key][i].context || context);
                    }
                }
            }
            return this;
        },

        // checks the status of a given field, and adds the class 'valid' or 'invalid' to the element based on
        // provided regex:
        /**
         * checks the status of a given field, and adds the class 'valid' or 'invalid' to the element based on
         * provided regex
         * @memberof methods
         * @param obj
         * @returns {boolean}
         */
        validateField : function (obj) {
            var $obj = $(obj);
            var type = $obj.attr('type');
            var name = $obj.data('ruleset') || $obj.attr('name');
            var test = _validateField.call(this, name, $obj);
            if (!test) {
                if (type !== "radio") {
                    $obj.removeClass('valid').addClass('invalid');
                }
                return false;
            }
            if (type !== "radio") {
                $obj.addClass('valid').removeClass('invalid');
            }
            return true;
        }

    };
    /**
     * Form Validation Plugin
     * @class
     * @param method {function} - a method belonging to the set of methods in {@link methods}
     * @param options {object} - any options associated with the method
     * @returns {*}
     */
    $.fn.dibsValidation = function (method, options) {

        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        }
        if (typeof method === 'object' || !method) {
            return methods.init.call(this, method, options);
        }
        $.error('Method ' +  method + ' does not exist on jQuery.dibsValidation');

        return this;
    };
    /**
     * @module dibsValidation
     * @type {Function|$.dibsValidation}
     */
    module.exports = $.fn.dibsValidation;

}));


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/libraries/plugins/dibs-validation.js
// module id = 433
// module chunks = 4 6 7 8 9 12 13 19 30 31 36